import $ from 'jquery';

const SigninAndUserAc = ({ username, passwordVal }) => {
    var response = false;
    $.ajax({
        url: "/api/app/login",
        async: false,
        method: 'POST',
        data: { "username": username, "password": passwordVal },
    }).done(function (res, statusText, xhr) {
        var status = xhr.status;
        if (status === 200) {
            localStorage.setItem("login_data", JSON.stringify(res));
            localStorage.setItem("access_token", " "+res.access_token);
            localStorage.setItem("expires_in", res.expires_in);
            response = userAccount();
        } else {
            response = false;
        }
    }).fail(function (res, statusText, xhr) {
        response = false;
    });
    return response;
}

const userAccount = () => {
    var response = false;
    $.ajax({
        url: "/api/user-account/me",
        async: false,
        method: 'POST',
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
            if (res.success === true) {
                localStorage.setItem("user_details", JSON.stringify(res.result));
                response = true;
            } else {
                response = false;
            }
        }
    });
    return response;
}

export default SigninAndUserAc;


// WEBPACK FOOTER //
// ./src/sales-desk/login/SigninAndUserAc.js